import { render, staticRenderFns } from "./reserveFund.vue?vue&type=template&id=4785f758&scoped=true"
import script from "./reserveFund.vue?vue&type=script&lang=js"
export * from "./reserveFund.vue?vue&type=script&lang=js"
import style0 from "./reserveFund.vue?vue&type=style&index=0&id=4785f758&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4785f758",
  null
  
)

export default component.exports